export default "__VITE_ASSET__CcI1eCOh__"